// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"kq-z","imageAndVideoCount":"lq-z","imageAndVideoContainer":"mq-z","viewAllReviews":"nq-z"};